module.exports = __webpack_public_path__ + "img/rectangle.326deb04.svg";